import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import {FormFieldHelpers as Form} from '../../../../../helpers';
import ThanksModal from '../../../../common/elements/ThanksModal';
import { withCookies, Cookies } from 'react-cookie';
import moment from 'moment';

const frequencyOptions = [{name: "never", id: 1}, {name: "daily", id: 2}, {name: "weekly", id: 3}];
const jobFrequencyOptions = [{name: "as posted", id: 4, img: "../../images/frequency-as-posted.png"}, {name: "daily", id: 2, img: "../../images/frequency-daily.png"}, {name: "weekly", id: 3, img: "../../images/frequency-weekly.png"}, {name: "never", id: 1, img: "../../images/frequency-never.png"}];
// const methodNames = [ 'Email only', 'Most suitable method' ];
// const subscriptionNames = ['Jobs', 'My Subscriptions', 'My Profile', 'Learning and development', 'Events', 'Network News', 'New Products and Services', 'Special Offers', "Complementary Services from our Partners" ];

class PreferencesForm extends Component {

    constructor(props) {
        super(props);

        this.handleSubmitPreferences = this.handleSubmitPreferences.bind(this);

        this.state = {
            isOpen: false,
        }
    }

    handleOnClose(e) {

        e.preventDefault();
        this.setState({isOpen: false});
    }

    handleSubmitPreferences( preferences ) {
        
        // console.log( 'LOG: PREFERENCES', preferences );

        const { handleFormSubmit, cookies } = this.props;
        this.setState({ isOpen: true });

        const date = moment();

        cookies.remove( 'expiry' );

        const newExpiry = date.add(3, 'months');

        cookies.set( 'expiry', newExpiry.format() )

        const prefs = [];

        if( preferences.jobs_member_services ) {
            prefs.push( { id: 10, opted_in: 1, frequency: preferences.frequency } );
        } else {
            prefs.push( { id: 10, opted_in: 0 } );
        }

        if( preferences.partnership_member_discounts ) {
            prefs.push( { id: 11, opted_in: 1 } );
        } else {
            prefs.push( { id: 11, opted_in: 0 } );
        }

        // console.log( "PREFS", prefs );

        handleFormSubmit ( prefs );
    }


    render() {


        const { submitFailed, handleSubmit, selectedJobMemberPrefs, selectedPartnershipDiscountPrefs, selectedFrequency, initialValues } = this.props;

	    return (
		    <div>
			    <form className="form-preferences" onSubmit={ handleSubmit (this.handleSubmitPreferences) } >

				    <div className="preferences-box preferences-box--expandable">
					    <div className="preferences-box__main background--laptop">
						    <div className="preferences-consent__body">
							    <div className="preferences__checkbox">
								    <Field
									    name="jobs_member_services"
									    label=""
									    component={ Form.checkboxFieldNoState }
									    onClick={ () => this.props.resetFrequency() }
								    />
								    <span className="checkbox__label">
									    { selectedJobMemberPrefs ? 'Great!' : 'Tick here!' }
								    </span>
							    </div>
							    <div className="preferences__copy">
								    <h5 className="h5">Latest Jobs <br/>&&nbsp;Member Services</h5>
								    <p className="p-tag">Looking for your next role? Let us help you with your search. Be the first to know when a job comes up that matches your requirements. Not to mention, invitations to the latest networking events, learning and development programmes  and industry news.</p>
							    </div>
						    </div>
					    </div>
					    {
						    selectedJobMemberPrefs &&
							    <div className="preferences-box__options">
								    <div className="preferences-options__body">
									    <h6 className="h6 title--uppercase">How frequent would you like to receive job emails?</h6>
									    <ul className="frequency--list frequency--job-emails">
										    {
											    selectedJobMemberPrefs &&
											    jobFrequencyOptions.map( ( frequency, index ) => {

												    const isChecked = frequency.id === parseInt( selectedFrequency, 10 );

												    return (
													    <li key={ index } className="frequency__item">
														    <div className="frequency-option">
															    <div className="option">
																    <div className={`option__spotlight${isChecked ? " selected" : ""}`}> </div>
																    <img src={ frequency.img } className="option__picture" alt=""/>
															    </div>
															    <Field
																    type="radio"
																    value={ frequency.id }
																    name="frequency"
																    component={ Form.radioFieldNoState }
																    label={ frequency.name }
																    checked={ isChecked }
															    />
														    </div>
													    </li>

												    );
											    } )
										    }
									    </ul>
								    </div>

							    </div>
					    }

				    </div>



				    <div className="preferences-box">
					    <div className="preferences-box__main background--business-cards">
						    <div className="preferences-consent__body">
							    <div className="preferences__checkbox">
								    <Field
									    name="partnership_member_discounts"
									    label=""
									    component={ Form.checkboxFieldNoState }
								    />
								    <span className="checkbox__label">
									    { selectedPartnershipDiscountPrefs ? 'Great!' : 'Tick here!' }
								    </span>
							    </div>
							    <div className="preferences__copy">
								    <h5 className="h5">Partnership Offers &&nbsp;Membership Discounts</h5>
								    <p className="p-tag">Receive the latest news and exclusive offers from our partner brands.</p>
							    </div>
						    </div>
					    </div>

				    </div>


				    <button action="submit" className="theme-button">
					    Save settings
				    </button>
			    </form>


			    <ThanksModal isOpen={ this.state.isOpen } onClose={ (e) => this.handleOnClose(e) }
			                 message="Your preferences have been submitted."/>
			    { submitFailed ? 'Error' : null }
		    </div>
	    );
    }
}

PreferencesForm = reduxForm({form: 'preferences'})(PreferencesForm);

const valueSelector = formValueSelector( 'preferences' );

const mapStateToProps = ( state ) => {
    return {
        selectedJobMemberPrefs: valueSelector( state, 'jobs_member_services'),
        selectedPartnershipDiscountPrefs: valueSelector( state, 'partnership_member_discounts'),
        selectedFrequency: valueSelector( state, 'frequency'),
        // initialValues: {
        //     jobs_member_services: true,
        //     frequency: 4,
        //     partnership_member_discounts: true,
        // }
        initialValues: state.account.initialValues,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        resetFrequency: () => dispatch( change( 'preferences', 'frequency', 1 ) ),
    };
};

export default withCookies( connect( mapStateToProps, mapDispatchToProps )( PreferencesForm ) );



// WEBPACK FOOTER //
// src/client/components/site/features/account/preferences/PreferencesForm.js